module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAALZJREFUKBW9UjEOhCAQnCUk6gssKSx5iZ1f8IHGSviDH6CwkS8YE6MW3sFdLllDZXFTMcvM7mSBrjfwAOKBJ1qobdtr33cURcF6nOcJIoKUktW3bUOe5yBjTIxa1zUTTNMEIQSqqmJ1a23kvN1XMs8zvPe/iUopZg4kaQyxsyyLxhArhaSxLEssyxKjhnMKchxHOOfQdR27D68UlnPHuq7QWoOGYbiO40DTNHdNkvd9/9nq3z/AC77NPCAazIJbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cajonera.png
// module id = 494
// module chunks = 0